import React from 'react';
import EvaluatorDashboard from '../pages/EvaluatorDashboard';
import { Routes, Route } from 'react-router-dom';
import SigninPage from '../features/authentication/Signin';
import { Toaster } from 'react-hot-toast';
import EvaluatorSummaryForm from '../features/assessment/EvaluatorForm/EvaluatorSummaryForm';
import SurveyComponent from '../features/survey/Survey';


function App() {
  console.log("femi v1 dep")

  const survey=[
    {
        "id": "f7aed267-0c3c-45d0-8e78-d15fb8880374",
        "question": "Did the staff greet the shopper upon entry?",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "145a5cc3-a42e-47d5-af4a-a08d74b4b0b0",
        "question": "Did the staff offer assistance or guidance?",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "a5c3dd0e-3621-4f0d-a81b-d30e5777093f",
        "question": "How friendly and approachable were the staff?",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "2190a24a-3b79-4ba8-bde6-ad7caa0a0265",
        "question": "Did the staff demonstrate sufficient product knowledge?",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "58f758b7-3a1e-4139-a4ef-ff493f429879",
        "question": "If manager is not on forecourt, ask trick questions to see if they ask for the manager.",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "88cac265-ba52-48aa-8b5c-ab21613deba4",
        "question": "Dispute resolution scenario: complain about inaccurate fuel bought at last visit.",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "8c819911-a489-47f9-bd4d-eb9339a36739",
        "question": "Check if cars are directed to the right pump (eyeball).",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "f20a40e4-0c23-408c-9997-9c409ba5bed7",
        "question": "Check for free flow of traffic, hawkers around and inside station.",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "8605a017-d74e-4c09-9e3c-70379a90853e",
        "question": "Traffic management - queues, availability of traffic controller with reflective jacket.",
        "isComment": false,
        "category": "Customer service",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "764466d8-fb80-4451-8b0f-064eaa33e236",
        "question": "Is station lit if shopping at night?",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "9181e2bc-bb4a-4b89-a0b8-9cdb92ed122b",
        "question": "Check cash handling (Carrying excess cash).",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "3fbfbac7-e8d5-47a5-8216-c5661f2c9b02",
        "question": "Check for extinguishers, bins, sand buckets and soapy water buckets (eyeball).",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "d1f96224-5bbc-4035-930c-437839d1bdbd",
        "question": "Check for safety signs around the station/forecourt (no smoking, switch off engine, etc.).",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "1721232d-f9cf-43ab-b373-3d166213ff6c",
        "question": "Did the site adhere to safety protocols? Mystery shopper will try to make a call during fuelling.",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "82547176-ebaf-44da-a6bf-cd189f3aff19",
        "question": "Were operational procedures followed accurately? Mystery shopper will keep car's ignition on while fueling.",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "0c77ad20-2411-4d88-96a9-5cfdb6e90dbc",
        "question": "Are emergency numbers (fire, police, hospital) available and visible?",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "f3950cd4-0a54-4554-bcdf-97025aaf44fc",
        "question": "Was station discharging and selling?",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "be3da93c-593b-4865-8fd8-2199b64ab535",
        "question": "Are cars/motorists coming from exit gate?",
        "isComment": false,
        "category": "Safety Checks around buying fuel",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "27a0720b-ad36-4f1f-8db6-d7c4376df3cb",
        "question": "Is station environment clean and well maintained?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "412d304b-de4f-4ac6-b554-4dcad61bb7f3",
        "question": "Are there overgrown grasses around station?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "6c55779b-f15c-4e9a-9bbd-58cba8d149c9",
        "question": "Are cars parked all over the station?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "ddaf08bd-94a0-48b7-b282-98734a8aa20b",
        "question": "Dressing/general appearance (uniform condition, name tags, shoes, etc.).",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "b2d3f2e0-b01c-4f8f-8a46-fcdb63115c28",
        "question": "Is station littered? Is there a cleaner on site?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "0b176bf8-b2b3-412d-96e3-cd9257d9333c",
        "question": "Check exit and entry gate if damaged.",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "68ede9ba-544b-4415-8aef-38374fa75ffe",
        "question": "General outlook of station (painting, damaged gates, etc.).",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "191d3ba0-219e-46ef-a170-2f2ca105ed20",
        "question": "For every visit, use toilet, enter NFR (supermarket, lube bay, carwash, restaurant) and eyeball cleanliness.",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "7e16f911-89f3-4eff-b72c-91c4d3bf90f6",
        "question": "Check accessibility of station. Is entry and exit free?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "4086f4fb-ba4d-4a46-b875-b89d4b076d11",
        "question": "Do they allow illegal parking for payment?",
        "isComment": false,
        "category": "Housekeeping/Toilet cleanliness/General Appearance",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "5d4fd7ab-3baf-4dca-ac89-218ad658150c",
        "question": "Check station in the morning and evening to confirm if they are selling.",
        "isComment": false,
        "category": "Wetness",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "654360d8-94a2-47c3-be2e-1ebc9e6d858c",
        "question": "Find out when sales commence and when sales ended from people around the station.",
        "isComment": false,
        "category": "Wetness",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "ac623a83-f957-41d0-a884-21e31ddd2078",
        "question": "Continue daily checks until stock is exhausted.",
        "isComment": false,
        "category": "Wetness",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "be77b1f7-7d07-419b-afbf-f9c790ce0f7a",
        "question": "Take picture of forecourt, note total number of pumps, are all pumps selling?",
        "isComment": false,
        "category": "Wetness",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "9ccfec38-c03e-414f-bda4-7c3904eb42cd",
        "question": "Check if lubricants are displayed on forecourt and around station in correct rack.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "9eb0a605-2da5-4ed2-8a77-3a8d233e39fb",
        "question": "Ask for lubricants (ask for 3 products) to check stock.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "bd67170b-367c-4534-9809-5921b08e9add",
        "question": "Check for sales of competitor lubricants and if they upsell own lubricants.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "08bec0ad-244f-4c48-92b2-ed3bde991c42",
        "question": "Confirm company's branding, merchandise (Lubes, LPG Cylinders) and signage are displayed.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "788a01c9-1076-40d1-b5e3-17dbfe3d18d7",
        "question": "Buy in kegs to check accuracy of pump (buy 5 litres).",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "2e06b557-8461-4e53-9161-b0439120dd4e",
        "question": "Ask for availability of AGO and buy to check price.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.726Z",
        "updatedAt": "2025-02-20T14:17:35.726Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "a5360f8c-5abc-497b-ada7-5521338835f7",
        "question": "Check price on mid and pump.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "650c21bc-d5fa-4121-8d91-4418d1008d6e",
        "question": "Compare actual price paid vs. price quoted on pump.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "a71d55a7-84de-4532-ba37-1ac2066cc1e3",
        "question": "Check available payment options (cash, POS, etc.). Was POS receipt issued?",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "03955d57-22e8-4830-b7f9-3666edafc0b9",
        "question": "Take picture of forecourt sales activity (discretely).",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "7256bb07-54f2-4ad0-bbf9-4b85d8094401",
        "question": "Check speed of service, efficiency, and duration of fuelling.",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "5b221cea-41fb-48e5-bd12-7d6244362959",
        "question": "Check how sales is being done (is attendant paying attention to pump or resting on the car?).",
        "isComment": false,
        "category": "Forecourt Sales",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "bdad79a7-a9eb-414c-a103-b2bd2a7f3e21",
        "question": "Rate the overall experience on a scale of 1 to 5.",
        "isComment": true,
        "category": "Overall Experience",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    },
    {
        "id": "9af94f22-2d77-42f4-bd0b-b18c574362aa",
        "question": "Any specific areas where improvements can be made?",
        "isComment": true,
        "category": "Overall Experience",
        "createdAt": "2025-02-20T14:17:35.727Z",
        "updatedAt": "2025-02-20T14:17:35.727Z",
        "options": [
            "Excellent",
            "Very Good",
            "Good",
            "Fair",
            "Poor"
        ],
        "options_value": [
            5,
            4,
            3,
            2,
            1
        ]
    }
]
  return (
    <>
      <Routes>
        <Route path="/" element={<SigninPage />} />
        <Route path="/form" element={<EvaluatorSummaryForm />} />
        <Route path="/survey/:projectId/:surveyId/:locationId" element={<SurveyComponent surveys={survey}/>} />
        <Route exact path="/evaluator"  element={<EvaluatorDashboard />} />
      </Routes>

      <Toaster />
    </>
  );
}

export default App;
